export default "__VITE_ASSET__C7A59XYD__"